import {
  InfoButton,
  Input,
  Label,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ChangeEventHandler } from "react"
import {
  useCallback,
  useRef,
} from "react"


import styles from "./AccountMedicationModal.module.scss"
import { usePolyglot } from "src/contexts"
import type { EditableAccountMedication } from "src/types"

interface Props {
  currentAccountMedication: EditableAccountMedication;
  editAccountMedication: (e: EditableAccountMedication) => void;
}

const id = "medication-units-input"
const polyglotPrefix = "components.account_medication_modal.units."

/*
 * renders a text input for entering medication units
 */
export function MedicationUnitsInput(props: Props) {
  const {
    currentAccountMedication,
    editAccountMedication,
  } = props

  const polyglot = usePolyglot()
  const inputRef = useRef<HTMLInputElement>(null)

  // update the currentAccountMedication's units
  const onUnitsChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      const units = e.target.value

      // update units
      editAccountMedication({
        ...currentAccountMedication,
        units,
      })
    },
    [
      currentAccountMedication,
      editAccountMedication,
    ],
  )

  return (
    <div>
      <Label
        htmlFor={id}
        sizePreset="small"
        className={styles.label}
        id="medication-units-label"
      >
        {polyglot.t(`${polyglotPrefix}label`)}
        <InfoButton title={polyglot.t(`${polyglotPrefix}info_title`)}>
          {polyglot.t(`${polyglotPrefix}info_description`)}
        </InfoButton>
      </Label>
      <Input
        className={styles.unitsInput}
        placeholder={polyglot.t(`${polyglotPrefix}placeholder`)}
        id={id}
        value={currentAccountMedication.units}
        onChange={onUnitsChange}
        type="text"
        ref={inputRef}
        required
      />
    </div>
  )
}
